import { Text } from 'Shared/forms/Inputs';
import { LabelOnRightWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export function GridGap()
{
	return (
		<StyleFieldsRow>
			<GridGapFields />
		</StyleFieldsRow>
	);
}


/* The column and row gaps of a grid widget, for a caller that names the location itself - see
   ruleProperties(). Each is a css length ('0', '10px', '2vw'); an empty box contributes nothing and
   the grid keeps Grid.tsx's 3vw / 4vw default for that axis. */
export function GridGapFields()
{
	return (<>
		<LabelOnRightWrap label='Column gap' narrow={true}>
			<Text field='columnGap' placeholder='e.g. 3vw' />
		</LabelOnRightWrap>
		<LabelOnRightWrap label='Row gap' narrow={true}>
			<Text field='rowGap' placeholder='e.g. 4vw' />
		</LabelOnRightWrap>
	</>);
}
